import { ScoreCard as ScoreCardForm } from '@/pages/ats-job-creation/tabs/interview-plan/stage/activity/activity-sections/schedule-interview';

export const Scorecard = ({
  formRef,
  questions = [],
  defaultScorecardParams = {},
  scorecardData = {},
  scorecardRequired = true,
  onScorecardRequiredChange = null,
}) => {
  return (
    <ScoreCardForm
      formRef={formRef}
      questions={questions}
      defaultScorecardParams={defaultScorecardParams}
      scorecardData={scorecardData}
      note="This is the recommended scorecard template. You can customize it but changes will only apply to this assessment."
      scorecardRequired={scorecardRequired}
      onScorecardRequiredChange={onScorecardRequiredChange}
    />
  );
};
